<template>
  <nav>
    <div class="navigation__container">
      <div class="nav__links">
        <img :src="mediaBaseUrl + 'landing/burger.svg'" alt="burger menu" @click="showMenu = true">
        <div class="menu">
          <a @click="() => handleLink(link.route, link.name)" v-for="link in links" :key="link.name" :class="{link_active: link.active}">{{link.name}}</a>
        </div>
      </div>

      <div class="nav__buttons">
<!--        <custom-button class="start-quiz" @click="handleQuizClick" :small="true">-->
<!--          {{$t('landing.startQuiz')}}-->
<!--        </custom-button>-->
        <div v-show="user === null" class="nav__buttons">
          <custom-button @click="handleLoginClick" :outlined="true" :small="true">
            {{ $t("landing.menu[4]") }}
          </custom-button>
        </div>
      </div>
    </div>

    <div class="menu" :class="{menu_active: showMenu}" @click="showMenu = false">
      <div class="close" @click="showMenu = false">
        <img :src="mediaBaseUrl + 'close.svg'" alt="close">
      </div>

      <template v-for="link in links">
        <a @click="() => handleLink(link.route, link.name)" :key="link.name">{{link.name}}</a>
      </template>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Navigation",

  inject: ["mediaBaseUrl"],

  props: ["user"],

  data() {
    return {
      showProfileMenu: false,
      showMenu: false,
      links: [
        {
          name: this.$t('landing.menu[0]'),
          route: "#features",
        },
        {
          name: this.$t('landing.menu[1]'),
          route: "#reviews",
        },
        {
          name: this.$t('landing.menu[2]'),
          route: "#faq",
        },
        {
          name: this.$t('landing.menu[3]'),
          route: "#contact",
        },
      ],
    };
  },

  computed: {
    tracker() {
      return this.$root.$children[0].$refs.tracker
    },
  },

  methods: {
    handleLoginClick() {
      this.$emit('modal', 'login');
    },
    handleLogout() {
      this.showProfileMenu = false;
      this.$emit("logout");
      this.$router.push("/");
    },
    handleQuizClick() {
      this.tracker.report('User_click_start_quiz');
      this.$router.push('/quiz');
    },
    handleLink(route, name) {
      this.tracker.report(`User_click_${name.toLowerCase()}`);
      this.$router.push(route);
    },
  },
}
</script>

<style lang="sass">
@import "../sass/variables"

nav
  position: absolute
  background: none
  width: 100%
  z-index: 10
  border-bottom: 1px solid rgba(255, 255, 255, 1)

  & > .menu
    display: none
    flex-direction: column
    align-items: center
    position: fixed
    background: rgba(255, 255, 255, 1)
    width: 100%
    height: 100lvh
    gap: 32px
    left: 0
    top: 0
    padding: 75px 16px 16px
    z-index: 101

    &.menu_active
      display: flex

    .close
      display: flex
      justify-content: center
      position: absolute
      align-items: center
      cursor: pointer
      left: 16px
      top: 32px
      background: #ffffff
      width: 48px
      height: 48px
      border-radius: 50%
      transition: .3s ease

      &:hover
        background: rgba(240, 240, 240, 1)

      &:active
        background: rgba(219, 219, 219, 1)

    a
      text-decoration: none
      font-size: 24px
      line-height: 33px
      font-weight: 400
      cursor: pointer
      transition: .3s ease

.navigation__container
  display: flex
  gap: 16px
  max-width: 1440px
  margin: 0 auto
  justify-content: space-between
  align-items: center
  padding: 16px
  position: relative

  .nav__links
    & > img
      display: block
      cursor: pointer

  .menu
    display: none
    flex-direction: column
    align-items: center
    position: relative
    gap: 40px

  .nav__buttons
    display: flex
    gap: 16px

  .nav__profile
    position: relative

    & > img
      cursor: pointer

  .profile__menu
    position: absolute
    top: calc(100% + 5px)
    right: 0
    background: rgba(255, 255, 255, 1)
    border-radius: 8px
    padding: 12px 0
    border: 1px solid rgba(235, 235, 235, 1)
    width: 180px
    z-index: 1

    div, a
      cursor: pointer
      display: flex
      align-items: center
      padding: 12px 24px
      font-size: 1rem
      line-height: 1.5rem
      font-weight: 400
      text-decoration: none
      color: rgba(35, 40, 48, 1)

      span
        color: rgba(35, 40, 48, 1)

      &:first-child
        path
          fill: rgba(42, 42, 42, 1)

      &:last-child
        path
          stroke: rgba(42, 42, 42, 1)

      path
        transition: .3s ease

      svg
        margin-right: 8px

  @media screen and (min-width: $lg)
    padding: 32px 16px

    .button
      padding: 16px 40px

    .nav__links
      & > img, .close
        display: none

      .menu
        display: flex
        position: relative
        flex-direction: row
        background: unset
        box-shadow: none
        width: auto
        height: auto
        backdrop-filter: none
        padding-top: 0

        a
          text-decoration: none
          font-size: 18px
          line-height: 27px
          font-weight: 400
          cursor: pointer
          transition: .3s ease
          color: rgba(255, 255, 255, 1)
          border-radius: 40px
          position: relative

          &:hover
            color: rgba(255, 255, 255, 0.6)

      a
        font-size: 20px
        line-height: 28px
</style>
